<script setup lang="ts">
import { UiDialog, UiIcon, UiText } from '@shopexperts/shared';
import type { PageSchemaFieldType } from '@shopexperts/shared';
import { PAGE_FIELD_TYPES } from '../../field-types';

const open = defineModel<boolean>({ required: true });

const emit = defineEmits<{
  addField: [type: PageSchemaFieldType];
}>();
</script>

<template>
  <UiDialog
    v-model="open"
    title="Add field"
    text="Choose the metafield type to add to this schema."
    size="lg"
  >
    <div class="grid gap-2 sm:grid-cols-2">
      <button
        v-for="definition in PAGE_FIELD_TYPES"
        :key="definition.type"
        type="button"
        class="flex min-w-0 items-center gap-3 rounded-md border border-se-gray-200 bg-white p-3 text-left hover:bg-se-gray-50"
        @click="emit('addField', definition.type)"
      >
        <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-se-gray-100">
          <UiIcon :name="definition.icon" class="h-4 w-4 text-se-gray-700" />
        </span>
        <span class="min-w-0">
          <UiText as="span" variant="p-small" class="block truncate text-se-dark" :text="definition.label" />
          <UiText as="span" variant="caption-normal" class="block truncate text-se-gray-700" :text="definition.type" />
        </span>
      </button>
    </div>
  </UiDialog>
</template>
